import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, catchError, map, of, shareReplay } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ImportadorConsultarResponse {
  success: boolean;
  msg: string;
  data: any[];
  requestId: string;
}

export interface ImportadorEjecutarResponse {
  success: boolean;
  msg: string;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class ImportadorService {

  private baseUrl: string = environment.apiaryDespachadorUrl;
  private permisoImportador$: Observable<boolean> | null = null;
  private headers = new HttpHeaders({ 'X-Secret': 'QA_importador_secret_2026' });

  constructor(private http: HttpClient) {}

  verificarPermiso(): Observable<boolean> {
    if (!this.permisoImportador$) {
      this.permisoImportador$ = this.http.get<any>(
        `${this.baseUrl}m2m/importador/tiene-permiso`, { headers: this.headers }
      ).pipe(
        map(resp => resp?.data?.tienePermiso === true),
        catchError(() => of(false)),
        shareReplay(1)
      );
    }
    return this.permisoImportador$;
  }

  consultar(fecha?: string): Observable<ImportadorConsultarResponse> {
    let url = `${this.baseUrl}m2m/importador/consultar`;
    if (fecha) {
      url += `?fecha=${fecha}`;
    }
    return this.http.get<ImportadorConsultarResponse>(url, { headers: this.headers }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  ejecutar(fecha: string, confirmar: boolean = false, tipoImportacion: string = 'jornadas_y_viajes'): Observable<ImportadorEjecutarResponse> {
    const body: any = { fecha, tipoImportacion };
    if (confirmar) {
      body.confirmar = true;
    }
    return this.http.post<ImportadorEjecutarResponse>(
      `${this.baseUrl}m2m/importador/ejecutar`, body, { headers: this.headers }
    ).pipe(
      catchError(error => throwError(() => error))
    );
  }

  obtenerLogs(id: number): Observable<string> {
    return this.http.get(
      `${this.baseUrl}m2m/importador/logs/${id}.txt?cache=${Math.random()}`, { headers: this.headers, responseType: 'text' }
    ).pipe(
      catchError(error => throwError(() => error))
    );
  }

  borrar(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.baseUrl}m2m/importador/borrar/${id}`, { headers: this.headers }
    ).pipe(
      catchError(error => throwError(() => error))
    );
  }
}
